export interface Country {
  code: string;
  name: string;
  flag: string;
}

const getFlagEmoji = (countryCode: string): string => {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
};

export const countries: Country[] = [
  { code: 'AF', name: 'Afghanistan', flag: getFlagEmoji('AF') },
  { code: 'AL', name: 'Albania', flag: getFlagEmoji('AL') },
  { code: 'DZ', name: 'Algeria', flag: getFlagEmoji('DZ') },
  { code: 'AS', name: 'American Samoa', flag: getFlagEmoji('AS') },
  { code: 'AD', name: 'Andorra', flag: getFlagEmoji('AD') },
  { code: 'AO', name: 'Angola', flag: getFlagEmoji('AO') },
  { code: 'AI', name: 'Anguilla', flag: getFlagEmoji('AI') },
  { code: 'AQ', name: 'Antarctica', flag: getFlagEmoji('AQ') },
  { code: 'AG', name: 'Antigua and Barbuda', flag: getFlagEmoji('AG') },
  { code: 'AR', name: 'Argentina', flag: getFlagEmoji('AR') },
  { code: 'AM', name: 'Armenia', flag: getFlagEmoji('AM') },
  { code: 'AW', name: 'Aruba', flag: getFlagEmoji('AW') },
  { code: 'AU', name: 'Australia', flag: getFlagEmoji('AU') },
  { code: 'AT', name: 'Austria', flag: getFlagEmoji('AT') },
  { code: 'AZ', name: 'Azerbaijan', flag: getFlagEmoji('AZ') },
  { code: 'BS', name: 'Bahamas', flag: getFlagEmoji('BS') },
  { code: 'BH', name: 'Bahrain', flag: getFlagEmoji('BH') },
  { code: 'BD', name: 'Bangladesh', flag: getFlagEmoji('BD') },
  { code: 'BB', name: 'Barbados', flag: getFlagEmoji('BB') },
  { code: 'BY', name: 'Belarus', flag: getFlagEmoji('BY') },
  { code: 'BE', name: 'Belgium', flag: getFlagEmoji('BE') },
  { code: 'BZ', name: 'Belize', flag: getFlagEmoji('BZ') },
  { code: 'BJ', name: 'Benin', flag: getFlagEmoji('BJ') },
  { code: 'BM', name: 'Bermuda', flag: getFlagEmoji('BM') },
  { code: 'BT', name: 'Bhutan', flag: getFlagEmoji('BT') },
  { code: 'BO', name: 'Bolivia', flag: getFlagEmoji('BO') },
  { code: 'BA', name: 'Bosnia and Herzegovina', flag: getFlagEmoji('BA') },
  { code: 'BW', name: 'Botswana', flag: getFlagEmoji('BW') },
  { code: 'BR', name: 'Brazil', flag: getFlagEmoji('BR') },
  { code: 'BN', name: 'Brunei', flag: getFlagEmoji('BN') },
  { code: 'BG', name: 'Bulgaria', flag: getFlagEmoji('BG') },
  { code: 'BF', name: 'Burkina Faso', flag: getFlagEmoji('BF') },
  { code: 'BI', name: 'Burundi', flag: getFlagEmoji('BI') },
  { code: 'KH', name: 'Cambodia', flag: getFlagEmoji('KH') },
  { code: 'CM', name: 'Cameroon', flag: getFlagEmoji('CM') },
  { code: 'CA', name: 'Canada', flag: getFlagEmoji('CA') },
  { code: 'CV', name: 'Cape Verde', flag: getFlagEmoji('CV') },
  { code: 'KY', name: 'Cayman Islands', flag: getFlagEmoji('KY') },
  { code: 'CF', name: 'Central African Republic', flag: getFlagEmoji('CF') },
  { code: 'TD', name: 'Chad', flag: getFlagEmoji('TD') },
  { code: 'CL', name: 'Chile', flag: getFlagEmoji('CL') },
  { code: 'CN', name: 'China', flag: getFlagEmoji('CN') },
  { code: 'CO', name: 'Colombia', flag: getFlagEmoji('CO') },
  { code: 'KM', name: 'Comoros', flag: getFlagEmoji('KM') },
  { code: 'CG', name: 'Congo', flag: getFlagEmoji('CG') },
  { code: 'CD', name: 'Congo, Democratic Republic', flag: getFlagEmoji('CD') },
  { code: 'CR', name: 'Costa Rica', flag: getFlagEmoji('CR') },
  { code: 'CI', name: 'Côte d\'Ivoire', flag: getFlagEmoji('CI') },
  { code: 'HR', name: 'Croatia', flag: getFlagEmoji('HR') },
  { code: 'CU', name: 'Cuba', flag: getFlagEmoji('CU') },
  { code: 'CY', name: 'Cyprus', flag: getFlagEmoji('CY') },
  { code: 'CZ', name: 'Czech Republic', flag: getFlagEmoji('CZ') },
  { code: 'DK', name: 'Denmark', flag: getFlagEmoji('DK') },
  { code: 'DJ', name: 'Djibouti', flag: getFlagEmoji('DJ') },
  { code: 'DM', name: 'Dominica', flag: getFlagEmoji('DM') },
  { code: 'DO', name: 'Dominican Republic', flag: getFlagEmoji('DO') },
  { code: 'EC', name: 'Ecuador', flag: getFlagEmoji('EC') },
  { code: 'EG', name: 'Egypt', flag: getFlagEmoji('EG') },
  { code: 'SV', name: 'El Salvador', flag: getFlagEmoji('SV') },
  { code: 'GQ', name: 'Equatorial Guinea', flag: getFlagEmoji('GQ') },
  { code: 'ER', name: 'Eritrea', flag: getFlagEmoji('ER') },
  { code: 'EE', name: 'Estonia', flag: getFlagEmoji('EE') },
  { code: 'ET', name: 'Ethiopia', flag: getFlagEmoji('ET') },
  { code: 'FJ', name: 'Fiji', flag: getFlagEmoji('FJ') },
  { code: 'FI', name: 'Finland', flag: getFlagEmoji('FI') },
  { code: 'FR', name: 'France', flag: getFlagEmoji('FR') },
  { code: 'GA', name: 'Gabon', flag: getFlagEmoji('GA') },
  { code: 'GM', name: 'Gambia', flag: getFlagEmoji('GM') },
  { code: 'GE', name: 'Georgia', flag: getFlagEmoji('GE') },
  { code: 'DE', name: 'Germany', flag: getFlagEmoji('DE') },
  { code: 'GH', name: 'Ghana', flag: getFlagEmoji('GH') },
  { code: 'GR', name: 'Greece', flag: getFlagEmoji('GR') },
  { code: 'GD', name: 'Grenada', flag: getFlagEmoji('GD') },
  { code: 'GT', name: 'Guatemala', flag: getFlagEmoji('GT') },
  { code: 'GN', name: 'Guinea', flag: getFlagEmoji('GN') },
  { code: 'GW', name: 'Guinea-Bissau', flag: getFlagEmoji('GW') },
  { code: 'GY', name: 'Guyana', flag: getFlagEmoji('GY') },
  { code: 'HT', name: 'Haiti', flag: getFlagEmoji('HT') },
  { code: 'HN', name: 'Honduras', flag: getFlagEmoji('HN') },
  { code: 'HK', name: 'Hong Kong', flag: getFlagEmoji('HK') },
  { code: 'HU', name: 'Hungary', flag: getFlagEmoji('HU') },
  { code: 'IS', name: 'Iceland', flag: getFlagEmoji('IS') },
  { code: 'IN', name: 'India', flag: getFlagEmoji('IN') },
  { code: 'ID', name: 'Indonesia', flag: getFlagEmoji('ID') },
  { code: 'IR', name: 'Iran', flag: getFlagEmoji('IR') },
  { code: 'IQ', name: 'Iraq', flag: getFlagEmoji('IQ') },
  { code: 'IE', name: 'Ireland', flag: getFlagEmoji('IE') },
  { code: 'IL', name: 'Israel', flag: getFlagEmoji('IL') },
  { code: 'IT', name: 'Italy', flag: getFlagEmoji('IT') },
  { code: 'JM', name: 'Jamaica', flag: getFlagEmoji('JM') },
  { code: 'JP', name: 'Japan', flag: getFlagEmoji('JP') },
  { code: 'JO', name: 'Jordan', flag: getFlagEmoji('JO') },
  { code: 'KZ', name: 'Kazakhstan', flag: getFlagEmoji('KZ') },
  { code: 'KE', name: 'Kenya', flag: getFlagEmoji('KE') },
  { code: 'KI', name: 'Kiribati', flag: getFlagEmoji('KI') },
  { code: 'KP', name: 'Korea, North', flag: getFlagEmoji('KP') },
  { code: 'KR', name: 'Korea, South', flag: getFlagEmoji('KR') },
  { code: 'KW', name: 'Kuwait', flag: getFlagEmoji('KW') },
  { code: 'KG', name: 'Kyrgyzstan', flag: getFlagEmoji('KG') },
  { code: 'LA', name: 'Laos', flag: getFlagEmoji('LA') },
  { code: 'LV', name: 'Latvia', flag: getFlagEmoji('LV') },
  { code: 'LB', name: 'Lebanon', flag: getFlagEmoji('LB') },
  { code: 'LS', name: 'Lesotho', flag: getFlagEmoji('LS') },
  { code: 'LR', name: 'Liberia', flag: getFlagEmoji('LR') },
  { code: 'LY', name: 'Libya', flag: getFlagEmoji('LY') },
  { code: 'LI', name: 'Liechtenstein', flag: getFlagEmoji('LI') },
  { code: 'LT', name: 'Lithuania', flag: getFlagEmoji('LT') },
  { code: 'LU', name: 'Luxembourg', flag: getFlagEmoji('LU') },
  { code: 'MO', name: 'Macao', flag: getFlagEmoji('MO') },
  { code: 'MK', name: 'Macedonia', flag: getFlagEmoji('MK') },
  { code: 'MG', name: 'Madagascar', flag: getFlagEmoji('MG') },
  { code: 'MW', name: 'Malawi', flag: getFlagEmoji('MW') },
  { code: 'MY', name: 'Malaysia', flag: getFlagEmoji('MY') },
  { code: 'MV', name: 'Maldives', flag: getFlagEmoji('MV') },
  { code: 'ML', name: 'Mali', flag: getFlagEmoji('ML') },
  { code: 'MT', name: 'Malta', flag: getFlagEmoji('MT') },
  { code: 'MH', name: 'Marshall Islands', flag: getFlagEmoji('MH') },
  { code: 'MR', name: 'Mauritania', flag: getFlagEmoji('MR') },
  { code: 'MU', name: 'Mauritius', flag: getFlagEmoji('MU') },
  { code: 'MX', name: 'Mexico', flag: getFlagEmoji('MX') },
  { code: 'FM', name: 'Micronesia', flag: getFlagEmoji('FM') },
  { code: 'MD', name: 'Moldova', flag: getFlagEmoji('MD') },
  { code: 'MC', name: 'Monaco', flag: getFlagEmoji('MC') },
  { code: 'MN', name: 'Mongolia', flag: getFlagEmoji('MN') },
  { code: 'ME', name: 'Montenegro', flag: getFlagEmoji('ME') },
  { code: 'MA', name: 'Morocco', flag: getFlagEmoji('MA') },
  { code: 'MZ', name: 'Mozambique', flag: getFlagEmoji('MZ') },
  { code: 'MM', name: 'Myanmar', flag: getFlagEmoji('MM') },
  { code: 'NA', name: 'Namibia', flag: getFlagEmoji('NA') },
  { code: 'NR', name: 'Nauru', flag: getFlagEmoji('NR') },
  { code: 'NP', name: 'Nepal', flag: getFlagEmoji('NP') },
  { code: 'NL', name: 'Netherlands', flag: getFlagEmoji('NL') },
  { code: 'NZ', name: 'New Zealand', flag: getFlagEmoji('NZ') },
  { code: 'NI', name: 'Nicaragua', flag: getFlagEmoji('NI') },
  { code: 'NE', name: 'Niger', flag: getFlagEmoji('NE') },
  { code: 'NG', name: 'Nigeria', flag: getFlagEmoji('NG') },
  { code: 'NO', name: 'Norway', flag: getFlagEmoji('NO') },
  { code: 'OM', name: 'Oman', flag: getFlagEmoji('OM') },
  { code: 'PK', name: 'Pakistan', flag: getFlagEmoji('PK') },
  { code: 'PW', name: 'Palau', flag: getFlagEmoji('PW') },
  { code: 'PS', name: 'Palestine', flag: getFlagEmoji('PS') },
  { code: 'PA', name: 'Panama', flag: getFlagEmoji('PA') },
  { code: 'PG', name: 'Papua New Guinea', flag: getFlagEmoji('PG') },
  { code: 'PY', name: 'Paraguay', flag: getFlagEmoji('PY') },
  { code: 'PE', name: 'Peru', flag: getFlagEmoji('PE') },
  { code: 'PH', name: 'Philippines', flag: getFlagEmoji('PH') },
  { code: 'PL', name: 'Poland', flag: getFlagEmoji('PL') },
  { code: 'PT', name: 'Portugal', flag: getFlagEmoji('PT') },
  { code: 'PR', name: 'Puerto Rico', flag: getFlagEmoji('PR') },
  { code: 'QA', name: 'Qatar', flag: getFlagEmoji('QA') },
  { code: 'RO', name: 'Romania', flag: getFlagEmoji('RO') },
  { code: 'RU', name: 'Russia', flag: getFlagEmoji('RU') },
  { code: 'RW', name: 'Rwanda', flag: getFlagEmoji('RW') },
  { code: 'KN', name: 'Saint Kitts and Nevis', flag: getFlagEmoji('KN') },
  { code: 'LC', name: 'Saint Lucia', flag: getFlagEmoji('LC') },
  { code: 'VC', name: 'Saint Vincent and the Grenadines', flag: getFlagEmoji('VC') },
  { code: 'WS', name: 'Samoa', flag: getFlagEmoji('WS') },
  { code: 'SM', name: 'San Marino', flag: getFlagEmoji('SM') },
  { code: 'ST', name: 'São Tomé and Príncipe', flag: getFlagEmoji('ST') },
  { code: 'SA', name: 'Saudi Arabia', flag: getFlagEmoji('SA') },
  { code: 'SN', name: 'Senegal', flag: getFlagEmoji('SN') },
  { code: 'RS', name: 'Serbia', flag: getFlagEmoji('RS') },
  { code: 'SC', name: 'Seychelles', flag: getFlagEmoji('SC') },
  { code: 'SL', name: 'Sierra Leone', flag: getFlagEmoji('SL') },
  { code: 'SG', name: 'Singapore', flag: getFlagEmoji('SG') },
  { code: 'SK', name: 'Slovakia', flag: getFlagEmoji('SK') },
  { code: 'SI', name: 'Slovenia', flag: getFlagEmoji('SI') },
  { code: 'SB', name: 'Solomon Islands', flag: getFlagEmoji('SB') },
  { code: 'SO', name: 'Somalia', flag: getFlagEmoji('SO') },
  { code: 'ZA', name: 'South Africa', flag: getFlagEmoji('ZA') },
  { code: 'SS', name: 'South Sudan', flag: getFlagEmoji('SS') },
  { code: 'ES', name: 'Spain', flag: getFlagEmoji('ES') },
  { code: 'LK', name: 'Sri Lanka', flag: getFlagEmoji('LK') },
  { code: 'SD', name: 'Sudan', flag: getFlagEmoji('SD') },
  { code: 'SR', name: 'Suriname', flag: getFlagEmoji('SR') },
  { code: 'SZ', name: 'Swaziland', flag: getFlagEmoji('SZ') },
  { code: 'SE', name: 'Sweden', flag: getFlagEmoji('SE') },
  { code: 'CH', name: 'Switzerland', flag: getFlagEmoji('CH') },
  { code: 'SY', name: 'Syria', flag: getFlagEmoji('SY') },
  { code: 'TW', name: 'Taiwan', flag: getFlagEmoji('TW') },
  { code: 'TJ', name: 'Tajikistan', flag: getFlagEmoji('TJ') },
  { code: 'TZ', name: 'Tanzania', flag: getFlagEmoji('TZ') },
  { code: 'TH', name: 'Thailand', flag: getFlagEmoji('TH') },
  { code: 'TL', name: 'Timor-Leste', flag: getFlagEmoji('TL') },
  { code: 'TG', name: 'Togo', flag: getFlagEmoji('TG') },
  { code: 'TO', name: 'Tonga', flag: getFlagEmoji('TO') },
  { code: 'TT', name: 'Trinidad and Tobago', flag: getFlagEmoji('TT') },
  { code: 'TN', name: 'Tunisia', flag: getFlagEmoji('TN') },
  { code: 'TR', name: 'Turkey', flag: getFlagEmoji('TR') },
  { code: 'TM', name: 'Turkmenistan', flag: getFlagEmoji('TM') },
  { code: 'TV', name: 'Tuvalu', flag: getFlagEmoji('TV') },
  { code: 'UG', name: 'Uganda', flag: getFlagEmoji('UG') },
  { code: 'UA', name: 'Ukraine', flag: getFlagEmoji('UA') },
  { code: 'AE', name: 'United Arab Emirates', flag: getFlagEmoji('AE') },
  { code: 'GB', name: 'United Kingdom', flag: getFlagEmoji('GB') },
  { code: 'US', name: 'United States', flag: getFlagEmoji('US') },
  { code: 'UY', name: 'Uruguay', flag: getFlagEmoji('UY') },
  { code: 'UZ', name: 'Uzbekistan', flag: getFlagEmoji('UZ') },
  { code: 'VU', name: 'Vanuatu', flag: getFlagEmoji('VU') },
  { code: 'VA', name: 'Vatican City', flag: getFlagEmoji('VA') },
  { code: 'VE', name: 'Venezuela', flag: getFlagEmoji('VE') },
  { code: 'VN', name: 'Vietnam', flag: getFlagEmoji('VN') },
  { code: 'YE', name: 'Yemen', flag: getFlagEmoji('YE') },
  { code: 'ZM', name: 'Zambia', flag: getFlagEmoji('ZM') },
  { code: 'ZW', name: 'Zimbabwe', flag: getFlagEmoji('ZW') }
];
